export default "__VITE_ASSET__BgJl6jzR__"